import { useState } from 'react'

import { Typography } from '@material-ui/core'
import { NonDismissibleDialog } from '@scoir/modals'

import api from 'common/api'

import { WarningContainedButton } from './LegacyButtons'

type WithdrawActionProps = {
  show: boolean
  onClose: () => void
  eventId: string
  highSchoolName: string
  onEventChange: () => void
}
const WithdrawAction = ({ show, onClose, eventId, highSchoolName, onEventChange }: WithdrawActionProps) => {
  const [isConfirming, setIsConfirming] = useState(false)
  const [error, setError] = useState(false)
  const withdraw = () => {
    setIsConfirming(true)
    api
      .delete(`/api/highschools/visits/${eventId}/register`)
      .then(() => {
        onEventChange()
        onClose()
        setIsConfirming(false)
        setError(false)
      })
      .catch(() => {
        setError(true)
        setIsConfirming(false)
      })
  }
  return (
    <NonDismissibleDialog
      open={show}
      headerText="Confirm Request Withdrawal"
      onClose={onClose}
    >
      <NonDismissibleDialog.Body>
        <span>Are you sure you want to withdraw this request for a visit?</span>
        <div className="shared-information-label">
          <strong>{highSchoolName}</strong> will be notified that you no longer wish to visit at this time.
        </div>
      </NonDismissibleDialog.Body>
      <NonDismissibleDialog.Footer>
        {error && (
          <Typography
            color="error"
            variant="body2"
          >
            An error occurred while attempting to withdraw the registration for this visit.
          </Typography>
        )}
        <NonDismissibleDialog.Footer.CloseButton>Cancel</NonDismissibleDialog.Footer.CloseButton>
        <NonDismissibleDialog.Footer.PrimaryActionButton
          disabled={isConfirming}
          onClick={() => withdraw()}
        >
          Confirm
        </NonDismissibleDialog.Footer.PrimaryActionButton>
      </NonDismissibleDialog.Footer>
    </NonDismissibleDialog>
  )
}

const Trigger = ({ onOpen }: { onOpen: () => void }) => {
  return (
    <WarningContainedButton
      variant="contained"
      color="secondary"
      size="small"
      onClick={() => onOpen()}
    >
      Withdraw Request
    </WarningContainedButton>
  )
}

WithdrawAction.Trigger = Trigger
export default WithdrawAction
